module.exports = __webpack_public_path__ + "static/media/sk.bc7b475b.png";